import { useEffect, useState } from 'react';

const useIsMobile = (isSmallerWidth) => {
  const [isMobile, setIsMobile] = useState(false);

  const handleWindowSizeChange = () => {
    const limitWidth = isSmallerWidth ? 767 : 1024;
    setIsMobile(window.innerWidth <= limitWidth);
  };
  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isMobile;
};

export default useIsMobile;
